import { FC } from 'react';

import { ProductAPIExplorerIcon } from '@twilio-paste/icons/esm/ProductAPIExplorerIcon';
import { ProductAlarmsIcon } from '@twilio-paste/icons/esm/ProductAlarmsIcon';
import { ProductAssetsIcon } from '@twilio-paste/icons/esm/ProductAssetsIcon';
import { ProductAuthyIcon } from '@twilio-paste/icons/esm/ProductAuthyIcon';
import { ProductConversationsIcon } from '@twilio-paste/icons/esm/ProductConversationsIcon';
import { ProductConnectionsIcon } from '@twilio-paste/icons/esm/ProductConnectionsIcon';
import { ProductElasticSIPTrunkingIcon } from '@twilio-paste/icons/esm/ProductElasticSIPTrunkingIcon';
import { ProductEmailAPIIcon } from '@twilio-paste/icons/esm/ProductEmailAPIIcon';
import { ProductFaxIcon } from '@twilio-paste/icons/esm/ProductFaxIcon';
import { ProductFlexIcon } from '@twilio-paste/icons/esm/ProductFlexIcon';
import { ProductFunctionsIcon } from '@twilio-paste/icons/esm/ProductFunctionsIcon';
import { ProductFrontlineIcon } from '@twilio-paste/icons/esm/ProductFrontlineIcon';
import { ProductInternetOfThingsIcon } from '@twilio-paste/icons/esm/ProductInternetOfThingsIcon';
import { ProductLookupIcon } from '@twilio-paste/icons/esm/ProductLookupIcon';
import { ProductMarketingCampaignsIcon } from '@twilio-paste/icons/esm/ProductMarketingCampaignsIcon';
import { ProductMessagingIcon } from '@twilio-paste/icons/esm/ProductMessagingIcon';
import { ProductNotifyIcon } from '@twilio-paste/icons/esm/ProductNotifyIcon';
import { ProductPhoneNumbersIcon } from '@twilio-paste/icons/esm/ProductPhoneNumbersIcon';
import { ProductPrivacyIcon } from '@twilio-paste/icons/esm/ProductPrivacyIcon';
import { ProductStudioIcon } from '@twilio-paste/icons/esm/ProductStudioIcon';
import { ProductSyncIcon } from '@twilio-paste/icons/esm/ProductSyncIcon';
import { ProductTaskRouterIcon } from '@twilio-paste/icons/esm/ProductTaskRouterIcon';
import { ProductTwiMLBinsIcon } from '@twilio-paste/icons/esm/ProductTwiMLBinsIcon';
import { ProductTwilioOrgIcon } from '@twilio-paste/icons/esm/ProductTwilioOrgIcon';
import { ProductVerifyIcon } from '@twilio-paste/icons/esm/ProductVerifyIcon';
import { ProductVideoIcon } from '@twilio-paste/icons/esm/ProductVideoIcon';
import { ProductVoiceIcon } from '@twilio-paste/icons/esm/ProductVoiceIcon';
import { LogoTwilioIcon } from '@twilio-paste/icons/esm/LogoTwilioIcon';
import { GenericIconProps } from '@twilio-paste/icons/esm/types';

import { types } from '../definitions';

export const getProductIcon = (
  name: types.ProductIconName,
): FC<GenericIconProps> => {
  const icons: { [key in types.ProductIconName]: FC<GenericIconProps> } = {
    ProductAlarmsIcon,
    ProductAPIExplorerIcon,
    ProductAssetsIcon,
    ProductAuthyIcon,
    ProductConversationsIcon,
    ProductConnectionsIcon,
    ProductElasticSIPTrunkingIcon,
    ProductEmailAPIIcon,
    ProductFaxIcon,
    ProductFlexIcon,
    ProductFunctionsIcon,
    ProductFrontlineIcon,
    ProductInternetOfThingsIcon,
    ProductLookupIcon,
    ProductMarketingCampaignsIcon,
    ProductMessagingIcon,
    ProductNotifyIcon,
    ProductPhoneNumbersIcon,
    ProductPrivacyIcon,
    ProductStudioIcon,
    ProductSyncIcon,
    ProductTaskRouterIcon,
    ProductTwiMLBinsIcon,
    ProductTwilioOrgIcon,
    ProductVerifyIcon,
    ProductVideoIcon,
    ProductVoiceIcon,
    LogoTwilioIcon,
  };

  const Icon = icons[name] || LogoTwilioIcon;

  return Icon;
};
